export default __webpack_public_path__ + "b0e1e2f04f824400519357a7d4086d66.png";